import { getCoreRowModel, useReactTable } from "@tanstack/react-table";

import Pagination from "@/components/pagination";
import Loading from "../layout/loading";
import useSorting from "./hooks/use-sorting";
import TableBody from "./table-body";
import TableHeader from "./table-header";

export default function DataTable({
  data,
  columns,
  totalItems,
  isLoading,
  initialSort = "",
}) {
  const { sorting, onSortingChange } = useSorting(initialSort);

  const { getHeaderGroups, getRowModel } = useReactTable({
    data,
    columns,
    manualSorting: true,
    onSortingChange,
    state: { sorting },
    getCoreRowModel: getCoreRowModel(),
    enableSortingRemoval: false,
    defaultColumn: {
      enableSorting: false,
    },
  });

  const headerGroups = getHeaderGroups();
  const rows = getRowModel().rows;

  if (isLoading) return <Loading />;

  return (
    <div className="mx-auto grid w-full grid-cols-1 gap-5">
      <div className="overflow-x-auto rounded-lg border shadow-md">
        <table className="min-w-full border-collapse bg-transparent">
          <TableHeader headerGroups={headerGroups} />
          <TableBody rows={rows} />
        </table>
      </div>
      <Pagination totalItems={totalItems} />
    </div>
  );
}
